import { Injectable } from '@angular/core';

import { DialogService } from './dialog.service';
import { DetailsComponent } from '../pages/questionnaire/details/details.component';

@Injectable({
  providedIn: 'root',
})
export class StartQuestionnaireService {
  constructor(private dialogService: DialogService) {}

  openSetupDialog(): void {
    this.dialogService.openDialog(DetailsComponent, {}, 1320, true);
  }
}
